export {default} from './GiftWithPurchase';

const isDiscounted = (item) => item.final_line_price === 0;
const hasMatchingGift = (item, gift) => item.product_id === gift.product_id;

export const getGiftWithPurchase = (gifts, items) => {
  const qualifiedGifts = [];
  const claimedGifts = [];
  const excludedGifts = [];
  const remainingSpend = [];

  gifts.forEach((gift) => {
    // If this gift is already in the cart return false
    const giftInCart = items.some((item) => hasMatchingGift(item, gift) && isDiscounted(item));

    if (giftInCart) {
      claimedGifts.push(gift);
      return;
    }

    // Check customer tier
    // -> customer is eligible if no tiers are set or if the customer's tier is in the list of eligible tiers
    const gwpCustomerEligibleTier = gift.customer_eligible_tiers?.map((tier) => tier.toLowerCase()) ?? [];
    const customerTier = window.theme?.customer?.tier?.toLowerCase() ?? null;
    const isTierEligible =
      !gwpCustomerEligibleTier.length || (customerTier && gwpCustomerEligibleTier.includes(customerTier));

    // Check minimum spend
    const minimumSpend = gift.minimum_spend ?? 0;
    const totalSpend = items.reduce((total, item) => total + item.final_line_price, 0);

    if (totalSpend < minimumSpend || !isTierEligible) {
      excludedGifts.push(gift);
      if (totalSpend < minimumSpend) {
        remainingSpend.push(minimumSpend - totalSpend);
      }
    } else {
      if (qualifiedGifts.length === 0 || minimumSpend > qualifiedGifts[0].minimum_spend) {
        qualifiedGifts.length = 0;
        qualifiedGifts.push(gift);
      } else if (minimumSpend === qualifiedGifts[0].minimum_spend) {
        qualifiedGifts.push(gift);
      }
    }
  });

  return {
    gifts: qualifiedGifts,
    excludedGifts,
    claimedGifts,
    remainingSpend,
  };
};
